module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Text/Itallic-0b0641c0c95d4c58e9b5c3dcd746ee76.svg";